import { CoreService } from '@charlesschwab/sac-ui-core';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SacAipIntent } from './sac-aip.intent';
import { IntegrationService } from './shared/services/integration.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'mutual-fund-investing-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'sac-aip-ui';
  applicationPath: string;
  firmName: string;
  firmId: string;
  userName: string;

  constructor(
    private intent: SacAipIntent,
    private integrationService: IntegrationService,
    private titleService: Title,
    private coreService: CoreService
  ) {
    this.applicationPath = this.intent.applicationPath;
    this.firmName = this.intent.firmName;
    this.userName = this.intent.userName;
  }

  ngOnInit(): void {
    this.integrationService.setApplicationPath(this.intent.applicationPath);
    this.integrationService.setFirmName(this.intent.firmName);
    this.integrationService.setFirmId(this.intent.firmId);
    this.integrationService.setUserId(this.intent.userName);
    this.integrationService.setSessionId(this.intent.sessionId);
    this.integrationService.setContext(this.intent.context);
    this.integrationService.setEnvironment(this.coreService.environment);
    this.integrationService.setIsEmployee(this.intent.isEmployee);
    this.titleService.setTitle('Automatic MF Investing');
  }
}
